import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const HolidayForm = ({ onSubmit, isSubmitting }) => {
  const navigate = useNavigate();

  const [holidayTraditions, setHolidayTraditions] = useState('');
  const [culturalFoods, setCulturalFoods] = useState('');

  useEffect(() => {
    const cookieData = Cookies.get('holidayInfo');
    if (cookieData) {
      try {
        const parsed = JSON.parse(cookieData);
        setHolidayTraditions(parsed.holidayTraditions || '');
        setCulturalFoods(parsed.culturalFoods || '');
      } catch (error) {
        console.error('Error parsing holidayInfo cookie:', error);
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const holidayData = {
      holidayTraditions,
      culturalFoods,
    };

    localStorage.setItem('holidayInfo', JSON.stringify(holidayData));
    Cookies.set('holidayInfo', JSON.stringify(holidayData), { expires: 30 });

    // navigate('/pathwayselection');
    onSubmit(holidayData);
  };

  return (
    <form className="container" onSubmit={handleSubmit}>
    <h5 className="fw-bold">Generate holiday or cultural celebration themes
    <img src={require("../../assets/images/ThemeStormerIcons/lunar.png")} width="39" className="p-1"></img> 
    <img src={require("../../assets/images/ThemeStormerIcons/tamales.png")} width="39" className="p-1"></img> 
    </h5>
    <p>Optional: Complete the fields below to help Conjuror generate some theme ideas.</p>
    <p className="mb-4 fst-italic text-success">If the fields are already filled with your previous inputs, feel free to edit them.</p>

    <div className="mb-3">
    <label className="form-label">
    Are there any upcoming holidays that some of your students celebrate?
    </label>
    <input
    type="text"
    className="form-control"
    value={holidayTraditions}
    onChange={(e) => setHolidayTraditions(e.target.value)}
    />
    </div>

    <div className="mb-3">
    <label className="form-label">
    Are there any foods that your students like or talk about?
    </label>
    <input
    type="text"
    className="form-control"
    value={culturalFoods}
    onChange={(e) => setCulturalFoods(e.target.value)}
    />
    </div>

    <div className="text-center">
    <button
      type="submit"
      className="btn btn-primary"
      disabled={isSubmitting}
    >
      {isSubmitting ? 'Generating ideas...' : 'Give me theme ideas'}
    </button>
    </div>
    </form>
    );
}

export default HolidayForm;